import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import FeatureTabs from './FeatureTabs'
import SubscriptionTabs from './SubscriptionTabs'
import './FeatureHub.less'

function FeatureHub ({ match }) {
  return (
    <div className="payment-feature-hub">
      <header className='main'>
        <h1>
          Features & Subscriptions
        </h1>
      </header>
      <SubscriptionTabs currentTab="features" />
      <div className='page-body'>
        <div className='block intro-block'>
          <h1>Your AWN Features</h1>
          <h2>Explore your tools & capabilities</h2>
          <p>Your plan gives you access to powerful features designed to help you get the most out of our platform.
Explore your current capabilities and learn what more you can do by discovering and unlocking additional advanced features.</p>
        </div>

        <div className='signup-banner'>
          <div className='banner-content'>
            <p>Get extended layers, expanded history, precision forecast and many more</p>
            <Link to="/welcome" className="btn btn-primary">Sign up now</Link>
          </div>
        </div>

        <FeatureTabs basePath='/subscriptions/features' match={match} />
      </div>
    </div>
  )
}

FeatureHub.propTypes = {}
FeatureHub.defaultProps = {}

export default withRouter(FeatureHub)

FeatureHub.displayName = 'FeatureHub'
